import React from 'react';

function Title({index, message}) {
	return message.text;
}

export default Title;